import React from 'react';
import { Box, Typography, Button, Modal } from '@mui/material';
import { motion } from 'framer-motion';

const RequireAuthModal = ({ open, onClose, onLogin }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(12px)',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
      }}
    >
      <Box
        component={motion.div}
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        sx={{
          position: 'relative',
          width: { xs: '90%', sm: '400px' },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: '0 25px 50px -12px rgba(59, 130, 246, 0.25)',
          p: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
          ログインが必要です
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          この機能を利用するにはログインが必要です。
          アカウントをお持ちでない方は、新規登録も可能です。
        </Typography>
        <Button
          variant="contained"
          onClick={onLogin}
          sx={{
            width: '100%',
            py: 1.5,
            background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
            },
          }}
        >
          ログインする
        </Button>
      </Box>
    </Modal>
  );
};

export default RequireAuthModal;
